import { Component, OnInit } from "@angular/core";
import { environment } from 'src/environments/environment';


@Component({
  selector: "app-thankyou",
  templateUrl: "./thankyou.component.html",
  styleUrls: ["./thankyou.component.scss"],
})
export class ThankyouComponent implements OnInit {

	constructor() {	}
	
	ngOnInit(){	}
}
